import React from 'react';

function ServicesHome() {
return(
 <div className="col-span-2 w-full text-white mt-8">
      <div className="serviceContainer grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5 w-full">
        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            EDICIÓN Y CONFORMADO
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Edición offline y online
            </li>
            <li className="service py-1 pl-5 relative">
              Conformado y EDL
            </li>
            <li className="service py-1 pl-5 relative">
              Sincronización multicámara
            </li>
            <li className="service py-1 pl-5 relative">
              Montaje final
            </li>
          </ul>
        </div>

        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            EFECTOS VISUALES
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Composición digital
            </li>
            <li className="service py-1 pl-5 relative">
              Rotoscopia y paint
            </li>
            <li className="service py-1 pl-5 relative">
              Motion tracking 3D
            </li>
            <li className="service py-1 pl-5 relative">
              Efectos de partículas
            </li>
            <li className="service py-1 pl-5 relative">
              Simulaciones físicas
            </li>
            <li className="service py-1 pl-5 relative">
              Matte painting digital
            </li>
            <li className="service py-1 pl-5 relative">
              Animación 3D
            </li>
            <li className="service py-1 pl-5 relative">
              Integración CGI
            </li>
          </ul>
        </div>

        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            DIGITAL INTERMEDIATE
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Corrección de color profesional
            </li>
            <li className="service py-1 pl-5 relative">
              Etalonaje digital
            </li>
            <li className="service py-1 pl-5 relative">
              Look development
            </li>
            <li className="service py-1 pl-5 relative">
              Mastering HDR/SDR
            </li>
            <li className="service py-1 pl-5 relative">
              Gestión de color 4K/8K
            </li>
          </ul>
        </div>

        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            AUDIO POSTPRODUCCIÓN
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Mezcla 5.1 y Dolby Atmos
            </li>
            <li className="service py-1 pl-5 relative">
              Diseño sonoro
            </li>
            <li className="service py-1 pl-5 relative">
              ADR y doblaje
            </li>
            <li className="service py-1 pl-5 relative">
              Foley recording
            </li>
            <li className="service py-1 pl-5 relative">
              Música y efectos
            </li>
            <li className="service py-1 pl-5 relative">
              Mastering audio
            </li>
          </ul>
        </div>

        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            FINISHING
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Conformado final
            </li>
            <li className="service py-1 pl-5 relative">
              Subtitulado y locución
            </li>
            <li className="service py-1 pl-5 relative">
              Masterización DCP
            </li>
            <li className="service py-1 pl-5 relative">
              Entrega multiplataforma
            </li>
            <li className="service py-1 pl-5 relative">
              Control de calidad
            </li>
            <li className="service py-1 pl-5 relative">
              Archivado digital
            </li>
          </ul>
        </div>

        <div className="service-category bg-opacity-5 p-5 rounded-lg">
          <h2 className="serviceTitle text-white text-lg uppercase tracking-wide mt-6 mb-2 px-1 py-1">
            SERVICIOS TÉCNICOS
          </h2>
          <ul className="list-none p-0 m-0 mb-5">
            <li className="service py-1 pl-5 relative">
              Digitalización y scanning
            </li>
            <li className="service py-1 pl-5 relative">
              Restauración digital
            </li>
            <li className="service py-1 pl-5 relative">
              Transcoding y encoding
            </li>
            <li className="service py-1 pl-5 relative">
              Gestión de metadatos
            </li>
            <li className="service py-1 pl-5 relative">
              Pipeline management
            </li>
          </ul>
        </div>
      </div>
    </div>
);
}

export default ServicesHome;